module.exports = __webpack_public_path__ + "img/IMG_8908.e0d2fe45.jpg";